import React, { useState } from 'react';

const VerifyToken = () => {
  const [email, setEmail] = useState('');
  const [token, setToken] = useState('');
  const [message, setMessage] = useState('');

  const handleVerify = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/email/verify-token`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, token }),
      });

      const data = await res.json();

      if (res.ok) {
        setMessage('✅ Verificación exitosa. Ya podés continuar.');
      } else {
        setMessage(`❌ ${data.error || 'Token inválido o expirado.'}`);
      }
    } catch (error) {
      console.error('Error:', error);
      setMessage('❌ Error al conectar con el servidor.');
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: 'auto', padding: 20 }}>
      <h2>Verificar código</h2>
      <input
        type="email"
        placeholder="Tu correo"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        style={{ width: '100%', marginBottom: 10, padding: 8 }}
      />
      <input
        type="text"
        placeholder="Código recibido"
        value={token}
        onChange={(e) => setToken(e.target.value)}
        style={{ width: '100%', marginBottom: 10, padding: 8 }}
      />
      <button onClick={handleVerify} style={{ width: '100%', padding: 10 }}>
        Verificar
      </button>
      {message && <p style={{ marginTop: 15 }}>{message}</p>}
    </div>
  );
};

export default VerifyToken;